"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./timer.scss");
function Timer(props) {
    var _a = (0, react_1.useState)(props.time), timeRemaining = _a[0], setTimeRemaining = _a[1];
    var convertMillisecondsToMMSS = function (milliseconds) {
        var seconds = milliseconds / 1000;
        var m = "0".concat(Math.floor(seconds / 60) % 60).slice(-2);
        var s = "0".concat(seconds % 60).slice(-2);
        return "".concat(m, ":").concat(s);
    };
    (0, react_1.useEffect)(function () {
        var interval = setInterval(function () {
            setTimeRemaining(function (timeRemaining) { return timeRemaining - 1000; });
        }, 1000);
        if (timeRemaining === 0) {
            clearInterval(interval);
            if (typeof props.callback === "function") {
                props.callback();
            }
        }
        return function () { return clearInterval(interval); };
    }, [timeRemaining, props]);
    return (react_1.default.createElement("div", { "aria-live": "polite", "aria-atomic": "true", className: "timer-wrapper mpng-ux-timer" },
        react_1.default.createElement("span", { className: "timer" }, convertMillisecondsToMMSS(timeRemaining))));
}
exports.default = Timer;
